export enum ConversationStatusEnum {
  Open = 'open',
  Resolved = 'resolved',
  // ConfirmedResolved = 'confirmed_resolved', // DO NOT USE! Not yet implemented on backend
}
